import { createAction } from '@reduxjs/toolkit';
import { RequestError, FluxClientsFilters, CustomersByStation, CustomersByOD } from 'types';

export const fetchCustomersByStation = createAction('customers-by-station/fetch', (payload: FluxClientsFilters) => ({
  payload,
}));

export const fetchedCustomersByStation = createAction(
  'customers-by-station/fetched',
  (data?: CustomersByStation, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);
export const fetchCustomersByOD = createAction('customers-by-OD/fetch', (payload: FluxClientsFilters) => ({
  payload,
}));

export const fetchedCustomersByOD = createAction(
  'customers-by-OD/fetched',
  (data?: CustomersByOD, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const exportCustomersByStation = createAction('customers-by-station/export', (payload: FluxClientsFilters) => ({
  payload,
}));

export const exportedCustomersByStation = createAction(
  'customers-by-station/exported',
  (data?: ArrayBuffer, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const refreshCustomersByStation = createAction(
  'customers-by-station/refresh',
  (payload: FluxClientsFilters) => ({
    payload,
  })
);

export const refreshedCustomersByStation = createAction(
  'customers-by-station/refreshed',
  (data?: CustomersByStation, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const exportCustomersByOD = createAction('customers-by-OD/export', (payload: FluxClientsFilters) => ({
  payload,
}));
export const exportedCustomersByOD = createAction(
  'customers-by-OD/exported',
  (data?: ArrayBuffer, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const refreshCustomersByOD = createAction('customers-by-OD/refresh', (payload: FluxClientsFilters) => ({
  payload,
}));
export const refreshedCustomersByOD = createAction(
  'customers-by-OD/refreshed',
  (data?: CustomersByOD, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const setFilters = createAction('customers/setFilters', (payload: FluxClientsFilters) => ({
  payload,
}));

export const resetFilters = createAction('customers/resetFilters');

export default {
  fetchCustomersByStation,
  fetchedCustomersByStation,
  fetchCustomersByOD,
  fetchedCustomersByOD,
  refreshCustomersByStation,
  refreshedCustomersByStation,
  exportCustomersByStation,
  exportedCustomersByStation,
  refreshCustomersByOD,
  refreshedCustomersByOD,
  exportCustomersByOD,
  exportedCustomersByOD,
  setFilters,
  resetFilters,
};
